import React, {useState} from "react";
import axios from 'axios';
import {useHistory} from 'react-router-dom'
import {faceBookPixel} from "@common-helpers/face-book-pixel"

import {getAnimationDurationClassName} from "@common-helpers/get-animation-duration-class-name"
import {setPathForRouter} from "@common-helpers/set-rout-path"
import {sendEventToArbitration} from "@common-helpers/arbitration-helper"
import {tiktokPixel} from "@common-helpers/tik-tok-pixel"
import {mailPixel} from "@common-helpers/mail-pixel"
import {SendUserData} from "@common-helpers/userData"

import {Button} from '@common-ui/btn'
import {Footer} from '@common-layout-components/footer'
import {Modal} from '@common-components/modal'

import loader from './img/loader.svg'

import './style.scss'

export const Registration = ({nextRout, nextPageId, isFirstPage}) => {

    const [error, setError] = useState(''),
        [isSubmitEnabled, setSubmitEnabled] = useState(false),
        [noAgreement, setAgreement] = useState(false),

        animationDurationClassName = getAnimationDurationClassName(),
        history = useHistory(),
        [loading, setLoading] = useState(false),

        language = localStorage.getItem('lang'),

        submitHandler = async (e) => {

            setLoading(() => true)

            const email = e.target.closest('.registration__content').querySelector('input[type=email]').value,
                formData = new FormData(),
                clickId = localStorage.getItem('click_id'),
                landingId = localStorage.getItem('landing-url').replace('/landing/', '');

            SendUserData({
                click_id: clickId,
                email: email
            });

            formData.append(`RegistrationForm[email]`, String(email))
            formData.append(`landingId`, String(landingId))

            if (clickId) {
                formData.append(`RegistrationForm[click_id]`, String(clickId))
            }

            const {data: dataTariff} = await axios.post(`/subscription-for-land/${landingId}`)

            const selectedTariffId = dataTariff[0].id

            formData.append(`subscription-plan`, String(selectedTariffId))

            const {data} = await axios.post(`/registration-from-land`, formData, {
                headers: {
                    'x-requested-with': 'XMLHttpRequest',
                    'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });

            if (data === 'user-was-success-created') {
                sendEventToArbitration(nextPageId - 1, 'REG');
                faceBookPixel('track', 'CompleteRegistration', {'external_id': localStorage.getItem('click_id')});
                tiktokPixel('CompleteRegistration')
                mailPixel('reachGoal', 'Registration')

                localStorage.setItem('trialId', selectedTariffId)
                localStorage.setItem('trialPrice', 0.9)

                if (isFirstPage) {
                    sendEventToArbitration(nextPageId - 1, 'INIT');
                    faceBookPixel('track', 'Lead', {'external_id': localStorage.getItem('click_id')})
                    tiktokPixel('ViewContent')
                }

                setLoading(() => false)
                setPathForRouter(nextRout, nextPageId, false, history)
            } else if (data === 'has error') {
                setLoading(() => false)
                setError('Что то пошло не так')
            } else if (data['registrationform-email']) {
                setLoading(() => false)
                setError(data['registrationform-email'][0])
            }

            e.preventDefault();
        },
        onCheckboxCheck = (event) => {
            setAgreement(!event.target.checked);
            setSubmitEnabled(event.target.checked);
        },
        checkAgreement = (event) => {
            setAgreement(true);
        }

    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(false);
    const openModalHandler = async (event) => {
        event.preventDefault();

        const {data} = await axios.get(event.target.href, {
            headers: {
                'x-requested-with': 'XMLHttpRequest',
            },
            responseType: 'html',
        });

        setModalOpen(true);
        setModalContent(data);
        document.querySelector('.modal_open').scrollTop = 0;
    }

    return (
        <div className={`content body-plan-mail-section ${animationDurationClassName}`}>

            <div className={`modal-loading ${loading && 'modal-loading_open'}`}>
                <img src={loader} alt=""/>
            </div>

            <div className="registration">
                <div className={'registration__content'}>
                    <div className="registration__title">Please enter your email, we will send a personalized training plan for you.</div>
                    <div className={"registration__mail"}>
                        <input type={'email'} className={`registration__mail-input${error.length>0?' error':''}`} placeholder={'Email'}/>
                        {error.length > 0
                            ? <p className="registration__mail-error">{error}</p>
                            : null}
                    </div>
                    <label className={`registration__label${noAgreement?' error':''}`}>
                        <input type={'checkbox'} onChange={onCheckboxCheck}/>
                        <div className={'registration__checkbox'}/>
                            <p>By performing any actions on the site, you give your consent and confirm that you have read these documents: <a href={'/terms'} onClick={openModalHandler}>Terms&Conditions</a>, <a href={'/privacy'} onClick={openModalHandler}>Privacy Policy</a>. The cost of the service is 0.9 euros and is regulated by the Tariff Plan. Subscription renews automatically every 30 days for 14.90 euros</p>
                        {noAgreement
                            ? <div className="registration__label-error">You must agree to the rules</div>
                            : null}
                    </label>
                    <div className={'submit__wrapper'}>
                        <div className={`submit-mock${!isSubmitEnabled?' disabled':''}`} onClick={checkAgreement}/>
                        <Button
                            onClick={submitHandler}
                            theme={'pink'}
                            disabled={!isSubmitEnabled}
                        >
                            Continue and Register
                        </Button>
                    </div>
                </div>
                <Footer theme={'pink'}>By using this site, you consent to the use of cookies to help us make it better and you are also agree to our <a href={'/privacy'} onClick={openModalHandler}>privacy policy</a>.</Footer>
            </div>
            <Modal
                isOpen={modalOpen}
                openHandler={setModalOpen}
                theme={'big'}
            >
                {modalContent}
            </Modal>
        </div>
    )
}
